import { Fragment, useRef, useState,useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import {toast} from 'react-toastify'
import Course from '../Dropdowns/CourseName'
import Scheme from '../Dropdowns/Scheme'
import Centre from '../Dropdowns/Centre'
import axiosInstance from '../../axios'
import AuthContext from "../../AuthContext";

export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) {
  const {
    centre_id,
    client_details,
    remark,
    financial_year,
    name_of_training_program,
    project_location,
    project_cost,
    sanction_order_no,
    project_duration,
    tot_training_target_allocated,
    sanction_order_id
     
  } = updateProductData;
  const authContext=useContext(AuthContext)
  const [update,setUpdate]=useState(false)
  const [open, setOpen] = useState(true);
  const [centre,setCentre]=useState(centre_id)
  const cancelButtonRef = useRef(null);
  const[order,setOrder]=useState({
    client_details:client_details,
    remarks :remark,
    location_of_project :project_location,
    total_target :tot_training_target_allocated,
    cost_of_project:project_cost,
    name_of_programe:name_of_training_program,
    sanction_no:sanction_order_no,
    financial_year :financial_year,
    duration:project_duration
  })
  const orders=true
  const center=authContext.userType==='Admin'?authContext.centre:centre
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setOrder(prevState => ({
      ...prevState,
      [name]: value
    }));
  }
  const updateProduct = async () => {
    try {
        await axiosInstance.put(`/sanctionorder/update/${sanction_order_id}`, {
          centre_id:centre,
          sanction_order_no:order.sanction_no,
          client_details:order.client_details,
          tot_training_target_allocated:order.total_target,
          name_of_training_program:order.name_of_programe,
          project_duration:order.duration,
          project_cost:order.cost_of_project,
          project_location:order.location_of_project,
          remark:order.remarks,
          financial_year:order.financial_year
        });

        toast.success('Sanction Order Updated');
        handlePageUpdate();
        updateModalSetting(false);
    } catch (err) {
      toast.error('Something went wrong')
        console.error('Update failed:', err);
    } finally {
        // Close the modal after successful update or error
        setOpen(false);
    }
};


  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left 
              shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Order
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        {authContext.userType==='Superadmin'&&
   <Centre value={centre} handleInputChange={(e)=>setCentre(e.target.value)} orders={orders}/>}
                            
                        <div>
                              <label htmlFor="financial_year"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Financial Year <span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="financial_year"
                            name="financial_year"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.financial_year}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="sanction_no"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Sanction No. <span className='text-red-600'>*</span></label>
                            <input
                            type="number"
                            id="sanction_no"
                            name="sanction_no"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.sanction_no}
                            onChange={handleInputChange}
                            />
                            </div>
                         
                            
                       
                          
                           
                            <div>
                              <label htmlFor="client_details"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >Client Details/ Sponsoring Agency
                               <span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="client_details"
                            name="client_details"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.client_details}
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                              <label htmlFor="total_target"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Total Training Target Allocated
                                <span className='text-red-600'>*</span></label>
                            <input
                            type="number"
                            id="total_target"
                            name="total_target"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                             
   value={order.total_target}
                            onChange={handleInputChange}
                            />
                            </div>
                           
                            <div>
                              <label htmlFor="name_of_programe"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Name of the Training Programme<span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="name_of_programe"
                            name="name_of_programe"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.name_of_programe}
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                              <label htmlFor="location_of_project"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Location of the Project <span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="location_of_project"
                            name="location_of_project"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.location_of_project}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="cost_of_project"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Cost of the Project
                              <span className='text-red-600'>*</span></label>
                            <input
                            type="number"
                            id="cost_of_project"
                            name="cost_of_project"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.cost_of_project}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="duration"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                              Duration of Project <span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="duration"
                            name="duration"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.duration}
                            onChange={handleInputChange}
                            />
                            </div> 
                            <div>
                              <label htmlFor="remarks"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                              Remarks <span className='text-red-600'>*</span></label>
                            <input
                            type="text"
                            id="remarks"
                            name="remarks"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.remarks}
                            onChange={handleInputChange}
                            />
                            </div> 
                          </div>
                          
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
